module.exports = wp.i18n;


//////////////////
// WEBPACK FOOTER
// external "wp.i18n"
// module id = 19
// module chunks = 0